// @Angular
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { PaginationModule } from 'ngx-bootstrap';

// Local modules
import { QRDocumentsPageRoutingModule } from './qr-documents-page-routing.module';
import { SharedModule } from '../shared/shared.module';
import { QRDocumentsPageComponent } from './qr-documents-page.component';


@NgModule({
  imports: [
    CommonModule,
    QRDocumentsPageRoutingModule,
    SharedModule,
    PaginationModule,
    Ng2SmartTableModule,
  ],
  declarations: [
    QRDocumentsPageComponent
  ]
})
export class QRDocumentsPageModule { }



// WEBPACK FOOTER //
// ./src/app/qr-documents-page/qr-documents-page.module.ts